<template>
  <div class="weui-uploader">
    <div class="weui-uploader__bd">
      <div
        class="weui-uploader__input-box"
        :style="fileBoxStyle"
        :class="{ 'weui-uploader__input-box__bgimage': value }"
      >
        <input
          class="weui-uploader__input"
          type="file"
          @change="onSelectFile"
          accept="image/*"
        />
      </div>
    </div>
  </div>
</template>

<script>
const baseURL = process.env.VUE_APP_API_URL || process.env.BASE_URL || '';

export default {
  props: {
    value: String,
  },
  computed: {
    fileBoxStyle() {
      var url = this.value;
      if (url) {
        return 'background-image: url("' + url + '");';
      }
      return "";
    },
  },
  methods: {
    /**
     * 上传文件
     */
    onSelectFile(e) {
      var me = this,
        data = new FormData(),
        files = e.target.files;
      if (!files.length) {
        return;
      }
      data.append("file", files[0]);
      me.$loading({
        url: "/api/file/upload",
        method: "POST",
        rawData: data
      })
        .then(function(res) {
          if (res.success) {
            me.$emit("input", baseURL + '/api/file/download?path=' + res.data.fullPath);
            me.$emit("select", res.data);
          } else {
            me.$weui.topTips("上传失败: " + res.message, 3000);
          }
        })
        .catch(function() {
          me.$weui.topTips("上传失败", 3000);
        });
    }
  },
};
</script>

<style scoped>
.weui-uploader {
  padding-top: 10px;
}
.weui-uploader__bd {
  display: flex;
  justify-content: center;
}
.weui-uploader__input-box {
  width: 115px;
  height: 115px;
}
.weui-uploader__input-box__bgimage {
  background-position: 0% 0%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: transparent;
  border: 1px dashed #d5d5d5;
}
</style>